const listShopEN = {
	title: "List Your Shop",
	subtitle: "Get bookings online",
	shopName: "Shop name",
	ownerName: "Owner name",
	email: "Email",
	phone: "Phone",
	shopDescription: "Short description of your shop",
	registerShop: "Register Shop",
	alreadyHaveAccount: "Already have an account?",
	signIn: "Sign in",
};

export default listShopEN;
